export default __webpack_public_path__ + "static/media/miguel-lopes-28.5b769b79.jpg";